import React, { Component } from 'react';
import PropTypes from 'prop-types';
import fetch from 'isomorphic-fetch';
import queryString from 'query-string';
import $ from 'jquery';

import Loader from '../components/Loader';
import NewsEventsContext from '../context/NewsEventsContext';

const stringToArray = arr => arr.split(' - ');
const formatString = arr => arr.toString();

const formatDateArray = (string, array) => {
  if (string.length > 0) {
    stringToArray(string).forEach(date => {
      const newDate = new Date(date);
      const formatedDate = newDate.toLocaleDateString('fr-CA');
      array.push(formatedDate);
    });
  }
};

const filterDuplicates = arr => {
  const seen = new Set();
  return arr.filter(el => {
    const dups = seen.has(el.nid[0].value);
    seen.add(el.nid[0].value);
    return !dups;
  });
};

const clearMulitSelect = () => {
  $('select[multiple]#news-events-discipline').multiselect('reset');
  $('select[multiple]#news-events-class-year').multiselect('reset');
};

const sortByDate = arr => {
  arr.sort((a, b) => {
    let dateA = a.dateDiff;
    let dateB = b.dateDiff;
    if (a.dateDiff === b.dateDiff) {
      return -1;
    }
    return dateB - dateA;
  });

  return arr.reverse();
};

export default class NewsEventsContainer extends Component {
  constructor() {
    super();
    this.state = {
      data: [],
      terms: [],
      termsDisciplines: [],
      ready: false,
      filter: 'all',
      discipline: '',
      classYear: '',
      search: '',
      eventDate: '',
      eventDateRangeStart: '',
      eventDateRangeEnd: '',
      club: '',
      group: '',
      theme: '',
      alumnus: '',
      eventLocation: '',
      type: '',
      offset: 0,
      clearFilters: e => {
        this.clearFilters(e);
      },
      handleRadio: e => {
        this.handleRadio(e);
      },
      handleSubmit: e => {
        this.handleSubmit(e);
      },
      loadMore: e => {
        this.loadMore(e);
      }
    };

    this.clearFilters = this.clearFilters.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.handleRadio = this.handleRadio.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.loadMore = this.loadMore.bind(this);
  }

  componentDidMount() {
    const parsed = queryString.parse(location.search);
    this.setState({
      filter: parsed.showing ? parsed.showing : 'all',
      search: parsed.text_search ? parsed.text_search : '',
      discipline: parsed.field_discipline_target_id ? parsed.field_discipline_target_id : '',
      classYear: parsed.field_class_year_value ? parsed.field_class_year_value : '',
      eventLocation: parsed.event_location ? parsed.event_location : '',
      eventDateRangeStart: parsed.date_after ? parsed.date_after : '',
      eventDateRangeEnd: parsed.date_before ? parsed.date_before : '',
      club: parsed.field_clubs_target_id ? parsed.field_clubs_target_id : '',
      alumnus: parsed.field_alumni_target_id ? parsed.field_alumni_target_id : '',
      theme: parsed.field_theme_target_id ? parsed.field_theme_target_id : '',
      group: parsed.field_groups_target_id ? parsed.field_groups_target_id : '',
      type: parsed.field_type_target_id ? parsed.field_type_target_id : ''
    });
    setTimeout(() => {
      this.fetchData('initial');
    }, 500);
  }

  handleRadio(e) {
    e.preventDefault();
    const { value } = e.target;
    this.setState({ filter: value });
  }

  loadMore(e) {
    e.preventDefault();
    let { offset } = this.state;

    this.setState({
      offset: (offset += 5)
    });

    setTimeout(() => {
      this.fetchData('loadMore');
    }, 500);
  }

  handleSubmit(e) {
    e.preventDefault();
    const discipline = document.querySelectorAll('#news-events-discipline option:checked');
    const classYear = document.querySelectorAll('#news-events-class-year option:checked');
    const search = document.getElementById('news-events-search').value;
    const eventDate = document.getElementById('news-events-event-date').value;
    const eventLocation = document.getElementById('news-events-event-location').value;
    const selectedDsicipline = [...discipline].map(item => item.value);
    const selectedClassYear = [...classYear].map(item => item.value);
    const eventDateArray = [];
    if (eventDate.length > 0) {
      formatDateArray(eventDate, eventDateArray);
    }

    this.setState({
      search,
      eventLocation,
      eventDateRangeStart: typeof eventDateArray[0] !== 'undefined' ? eventDateArray[0] : '',
      eventDateRangeEnd: typeof eventDateArray[1] !== 'undefined' ? eventDateArray[1] : '',
      discipline: formatString(selectedDsicipline),
      classYear: formatString(selectedClassYear),
      offset: 0
    });
    setTimeout(() => {
      this.fetchData();
    }, 500);
  }

  async fetchData(type) {
    const {
      discipline,
      search,
      eventLocation,
      classYear,
      offset,
      filter,
      eventDateRangeStart,
      eventDateRangeEnd,
      data,
      club,
      alumnus,
      group,
      theme
    } = this.state;
    const postType = this.state.type;
    const btnLoadMore = document.querySelector('.btn-load-more');

    const disciplineParam =
      discipline.length > 0 ? `&field_discipline_target_id=${discipline}` : '';
    const searchParam = search ? `&text_search=${search}` : '';
    const classYearParam = classYear.length > 0 ? `&field_class_year_value=${classYear}` : '';
    const eventLocationParam = eventLocation ? `&event_location=${eventLocation}` : '';
    const eventDateRangeStartParam = eventDateRangeStart
      ? `&date_after=${eventDateRangeStart}`
      : '';
    const eventDateRangeEndParam = eventDateRangeEnd ? `&date_before=${eventDateRangeEnd}` : '';
    const offsetParam = `&offset=${offset}`;
    const pageUrl = `/news-events?showing=${filter}${disciplineParam}${searchParam}${classYearParam}${eventLocationParam}${eventDateRangeEndParam}${eventDateRangeStartParam}`;

    // Filters not available on the front end
    const clubParam = club.length > 0 ? `&field_clubs_target_id=${club}` : '';
    const alumnusParam = alumnus.length > 0 ? `&field_alumni_target_id=${alumnus}` : '';
    const groupParam = group.length > 0 ? `&field_groups_target_id=${group}` : '';
    const themeParam = theme.length > 0 ? `&field_theme_target_id=${theme}` : '';
    const typeParam = postType.length > 0 ? `&field_type_target_id=${postType}` : '';

    const apiEventsFuture = `/api/future_events?_format=json${disciplineParam}${searchParam}${classYearParam}${eventLocationParam}${eventDateRangeEndParam}${eventDateRangeStartParam}${offsetParam}${clubParam}${alumnusParam}${groupParam}${themeParam}${typeParam}`;
    const apiEventsPast = `/api/past_events?_format=json${disciplineParam}${searchParam}${classYearParam}${eventLocationParam}${eventDateRangeEndParam}${eventDateRangeStartParam}${offsetParam}${clubParam}${alumnusParam}${groupParam}${themeParam}${typeParam}`;
    const apiNews = `/api/news?_format=json${disciplineParam}${searchParam}${classYearParam}${offsetParam}${clubParam}${alumnusParam}${groupParam}${themeParam}${typeParam}`;
    const apiFeatured = `/api/featured?_format=json${disciplineParam}${searchParam}${classYearParam}${eventLocationParam}${eventDateRangeEndParam}${eventDateRangeStartParam}${clubParam}${alumnusParam}${groupParam}${themeParam}${typeParam}`;
    const apiTerms = '/api/terms?_format=json';
    const apiTermsDisciplines = 'api/terms/disciplines?_format=json';

    if (type === 'initial') {
      try {
        const fetchFeatured = await fetch(apiFeatured);
        const fetchNews = await fetch(apiNews);
        const fetchEventsFuture = await fetch(apiEventsFuture);
        const fetchEventsPast = await fetch(apiEventsPast);
        const fetchTerms = await fetch(apiTerms);
        const fetchTermsDisciplines = await fetch(apiTermsDisciplines);

        if (!fetchTermsDisciplines.ok) {
          throw Error(fetchTermsDisciplines.statusText);
        }
        if (!fetchFeatured.ok) {
          throw Error(fetchFeatured.statusText);
        }
        if (!fetchNews.ok) {
          throw Error(fetchNews.statusText);
        }
        if (!fetchEventsFuture.ok) {
          throw Error(fetchEventsFuture.statusText);
        }
        if (!fetchEventsPast.ok) {
          throw Error(fetchEventsPast.statusText);
        }
        if (!fetchTerms.ok) {
          throw Error(fetchTerms.statusText);
        }
        const featured = await fetchFeatured.json();
        const news = await fetchNews.json();
        const eventsFuture = await fetchEventsFuture.json();
        const eventsPast = await fetchEventsPast.json();
        const events = eventsFuture.concat(eventsPast);
        const newsEvents = news.concat(eventsFuture, eventsPast);
        const sortedNewsEvents = sortByDate(newsEvents);
        const terms = await fetchTerms.json();
        const termsDisciplines = await fetchTermsDisciplines.json();
        const featuredNewsEvents = filterDuplicates([...featured.concat(sortedNewsEvents)]);
        const featuredNews = filterDuplicates([...featured.concat(news)]);
        const featuredEvents = filterDuplicates([...featured.concat(events)]);

        if (filter === 'all') {
          if (eventLocation) {
            this.setState({ filter: 'events', data: featuredEvents });
          } else {
            this.setState({ data: featuredNewsEvents });
          }
        }
        if (filter === 'news') {
          if (featured.length === 1 && featured[0].type[0].target_id === 'news') {
            this.setState({ data: featuredNews });
          } else {
            this.setState({ data: news });
          }
        }
        if (filter === 'events') {
          if (featured.length === 1 && featured[0].type[0].target_id === 'event') {
            this.setState({ data: featuredEvents });
          } else {
            this.setState({ data: events });
          }
        }
        this.setState({
          terms,
          termsDisciplines,
          ready: true
        });
      } catch (error) {
        console.log(error);
      }
    } else if (type === 'clear') {
      try {
        const fetchFeatured = await fetch('/api/featured?_format=json');
        const fetchNews = await fetch('/api/news?_format=json');
        const fetchEventsFuture = await fetch('/api/future_events?_format=json');
        const fetchEventsPast = await fetch('/api/past_events?_format=json');
        const fetchTerms = await fetch(apiTerms);

        if (!fetchFeatured.ok) {
          throw Error(fetchFeatured.statusText);
        }
        if (!fetchNews.ok) {
          throw Error(fetchNews.statusText);
        }
        if (!fetchEventsFuture.ok) {
          throw Error(fetchEventsFuture.statusText);
        }
        if (!fetchEventsPast.ok) {
          throw Error(fetchEventsPast.statusText);
        }

        const featured = await fetchFeatured.json();
        const news = await fetchNews.json();
        const eventsFuture = await fetchEventsFuture.json();
        const eventsPast = await fetchEventsPast.json();
        const newsEvents = news.concat(eventsFuture, eventsPast);
        const sortedNewsEvents = sortByDate(newsEvents);
        const featuredNewsEvents = filterDuplicates([...featured.concat(sortedNewsEvents)]);

        this.setState({ data: featuredNewsEvents });
        btnLoadMore.classList.remove('is-hidden');
      } catch (error) {
        console.log(error);
      }
    } else if (type === 'loadMore') {
      if (filter === 'all') {
        try {
          const fetchNews = await fetch(apiNews);
          const fetchEventsFuture = await fetch(apiEventsFuture);
          const fetchEventsPast = await fetch(apiEventsPast);

          if (!fetchNews.ok) {
            throw Error(fetchNews.statusText);
          }
          if (!fetchEventsFuture.ok) {
            throw Error(fetchEventsFuture.statusText);
          }
          if (!fetchEventsPast.ok) {
            throw Error(fetchEventsPast.statusText);
          }

          const news = await fetchNews.json();
          const eventsFuture = await fetchEventsFuture.json();
          const eventsPast = await fetchEventsPast.json();
          const newsEvents = news.concat(eventsFuture, eventsPast);
          const sortedNewsEvents = sortByDate(newsEvents);
          const filteredNewsEvents = filterDuplicates([...data, ...data.concat(sortedNewsEvents)]);
          const events = eventsFuture.concat(eventsPast);
          const sortedEvents = sortByDate(events);
          const filteredEvents = filterDuplicates(sortedEvents);

          if (news.length < 5 && eventsFuture.length < 5 && eventsPast.length < 5) {
            btnLoadMore.classList.add('is-hidden');
          }

          if (eventLocation) {
            this.setState({ filter: 'events', data: filteredEvents });
          } else {
            this.setState({ data: filteredNewsEvents });
          }
        } catch (error) {
          console.log(error);
        }
      }

      if (filter === 'news') {
        try {
          const fetchNews = await fetch(apiNews);

          if (!fetchNews.ok) {
            throw Error(fetchNews.statusText);
          }

          const news = await fetchNews.json();

          if (news.length < 5) {
            btnLoadMore.classList.add('is-hidden');
          }
          const filteredNews = filterDuplicates([...data.concat(news)]);
          this.setState({ data: filteredNews });
        } catch (error) {
          console.log(error);
        }
      }

      if (filter === 'events') {
        try {
          const fetchEventsFuture = await fetch(apiEventsFuture);
          const fetchEventsPast = await fetch(apiEventsPast);
          if (!fetchEventsFuture.ok) {
            throw Error(fetchEventsFuture.statusText);
          }
          if (!fetchEventsPast.ok) {
            throw Error(fetchEventsPast.statusText);
          }

          const eventsFuture = await fetchEventsFuture.json();
          const eventsPast = await fetchEventsPast.json();
          const events = eventsFuture.concat(eventsPast);
          const filteredEvents = filterDuplicates([...data.concat(events)]);

          if (filteredEvents.length < 5) {
            btnLoadMore.classList.add('is-hidden');
          }

          this.setState({ data: filteredEvents });
        } catch (error) {
          console.log(error);
        }
      }
    } else {
      window.history.pushState('news-events', 'Title', pageUrl);
      if (filter === 'all') {
        try {
          const fetchFeatured = await fetch(apiFeatured);
          const fetchNews = await fetch(apiNews);
          const fetchEventsFuture = await fetch(apiEventsFuture);
          const fetchEventsPast = await fetch(apiEventsPast);

          if (!fetchFeatured.ok) {
            throw Error(fetchFeatured.statusText);
          }
          if (!fetchNews.ok) {
            throw Error(fetchNews.statusText);
          }
          if (!fetchEventsFuture.ok) {
            throw Error(fetchEventsFuture.statusText);
          }
          if (!fetchEventsPast.ok) {
            throw Error(fetchEventsPast.statusText);
          }

          const featured = await fetchFeatured.json();
          const news = await fetchNews.json();
          const eventsFuture = await fetchEventsFuture.json();
          const eventsPast = await fetchEventsPast.json();
          const newsEvents = news.concat(eventsFuture, eventsPast);
          const sortedNewsEvents = sortByDate(newsEvents);
          const filteredNewsEvents = filterDuplicates(sortedNewsEvents);
          const featuredNewsEvents = filterDuplicates([...featured.concat(filteredNewsEvents)]);
          const events = eventsFuture.concat(eventsPast);
          const sortedEvents = sortByDate(events);
          const filteredEvents = filterDuplicates(sortedEvents);
          const featuredEvents = filterDuplicates([...featured.concat(events)]);

          if (featuredNewsEvents.length === 0 || filteredNewsEvents.length === 0) {
            btnLoadMore.classList.add('is-hidden');
          } else {
            btnLoadMore.classList.remove('is-hidden');
          }

          if (featured.length === 1) {
            if (eventLocation) {
              this.setState({ filter: 'events', data: featuredEvents });
            } else {
              this.setState({ data: featuredNewsEvents });
            }
          } else {
            if (eventLocation) {
              this.setState({ filter: 'events', data: filteredEvents });
            } else {
              this.setState({ data: filteredNewsEvents });
            }
          }
        } catch (error) {
          console.log(error);
        }
      }

      if (filter === 'news') {
        try {
          const fetchFeatured = await fetch(apiFeatured);
          const fetchNews = await fetch(apiNews);

          if (!fetchFeatured.ok) {
            throw Error(fetchFeatured.statusText);
          }
          if (!fetchNews.ok) {
            throw Error(fetchNews.statusText);
          }

          const featured = await fetchFeatured.json();
          const news = await fetchNews.json();
          const featuredNews = filterDuplicates([...featured.concat(news)]);

          if (featured.length === 0 && news.length < 5) {
            btnLoadMore.classList.add('is-hidden');
          } else {
            btnLoadMore.classList.remove('is-hidden');
          }

          if (featured.length === 1 && featured[0].type[0].target_id === 'news') {
            this.setState({ data: featuredNews });
          } else {
            this.setState({ data: news });
          }
        } catch (error) {
          console.log(error);
        }
      }

      if (filter === 'events') {
        try {
          const fetchFeatured = await fetch(apiFeatured);
          const fetchEventsFuture = await fetch(apiEventsFuture);
          const fetchEventsPast = await fetch(apiEventsPast);

          if (!fetchFeatured.ok) {
            throw Error(fetchFeatured.statusText);
          }
          if (!fetchEventsFuture.ok) {
            throw Error(fetchEventsFuture.statusText);
          }
          if (!fetchEventsPast.ok) {
            throw Error(fetchEventsPast.statusText);
          }

          const featured = await fetchFeatured.json();
          const eventsFuture = await fetchEventsFuture.json();
          const eventsPast = await fetchEventsPast.json();
          const events = eventsFuture.concat(eventsPast);
          const featuredEvents = filterDuplicates([...featured.concat(events)]);

          if (featured.length === 0 && events.length < 5) {
            btnLoadMore.classList.add('is-hidden');
          } else {
            btnLoadMore.classList.remove('is-hidden');
          }

          if (featured.length === 1 && featured[0].type[0].target_id === 'events') {
            this.setState({ data: featuredEvents });
          } else {
            this.setState({ data: events });
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
  }

  clearFilters(e) {
    e.preventDefault();
    e.stopPropagation();
    const eventLocation = document.getElementById('news-events-event-location');
    const search = document.getElementById('news-events-search');

    window.history.pushState(null, '', '/news-events');
    this.setState({
      data: [],
      filter: 'all',
      discipline: '',
      classYear: '',
      search: '',
      eventDateRangeStart: '',
      eventDateRangeEnd: '',
      eventLocation: '',
      offset: 1
    });

    var clearDatePicker = document.getElementsByClassName('datetimepicker-clear-button')[0];
    if (clearDatePicker.offsetParent) {
      clearDatePicker.click();
    }
    eventLocation.value = '';
    search.value = '';
    clearMulitSelect();
    this.fetchData('clear');
  }

  render() {
    const { ready } = this.state;
    const { children } = this.props;

    if (!ready) return <Loader />;
    return <NewsEventsContext.Provider value={this.state}>{children}</NewsEventsContext.Provider>;
  }
}

NewsEventsContainer.propTypes = {
  children: PropTypes.shape({}).isRequired
};
